import React from 'react';

import MiceTemplate from '../miceTemplate';
import MiceApp from './MiceApp';
import { NavigationLinks } from './config';

function MiceSeo(props) {
	return (
		<MiceTemplate {...props} headerLinks={NavigationLinks}>
			<MiceApp />
		</MiceTemplate>

	);
}

export default MiceSeo;
